import WithPreferences from "./WithPreferences";
export default WithPreferences;
